<template>
  <div class="relative">
    <i-mdi-marker />
    <span
      :class="colorClass"
      class="absolute inset-x-0 -bottom-0.5 h-1 rounded bg-current fill-current"
    ></span>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  colorClass?: string;
}>();
</script>
